
import {  inject, reactive, ref } from "vue";
import Popular from "@/components/filtrate/popular.vue";
import goodsList from "@/components/goods/goods-list.vue";
import Header from "@/components/header/header.vue";
import ShopTabs from './shop-tabs.vue'
import {useRouter,useRoute} from 'vue-router'
import { formatSearchResult } from "@/views/search/search-listings.vue";
export default {
  components: {
    Popular,
    Header,
    goodsList,
    ShopTabs
  },
  setup() {
    const $http: any = inject("$http");
    let  route = useRoute();
     let  router = useRouter();
     let searchKeyword = ref(route.query.keywords ? route.query.keywords : '');
    let banner: any = reactive({
        product_rank: [],
      }),     
      parameter = reactive({
        size: 10,
        page: 1,
        order: '1',
        store_id: route.query.id ? route.query.id : '',
        keyword:route.query.keywords ? route.query.keywords : ''
      }),
      loading = ref(false),
      finished = ref(false);
      
    //产品
    const onLoad = () => {
      const { size, page, order, store_id, keyword } = parameter
      console.log("🚀 ~ onLoad ~ order:", order)
      const params: ISearchV2Params = {
        size,
        page,
        o: order ? Number(order) as any : '',
        store_id: (store_id || '') as any,
        q: keyword as string
      }
      $http
        .searchV2(params)
        .then((res: any) => {
          const formatResult = formatSearchResult(res.data)
          if (formatResult.products.length > 0) {
            banner.product_rank = banner.product_rank.concat(formatResult.products);
            parameter.page = parameter.page + 1;
            loading.value = false;
            if (formatResult.products.length < parameter.size) {
              finished.value = true;
            }
          } else {
            finished.value = true;
          }
        });
    };
    //获取最新最热高低价格~~
    const screeningClick = (value: string) => {
      loading.value = false
      finished.value = false
      parameter.order = value;
      banner.product_rank = [];
      parameter.page = 1;
      onLoad();
    };
    const onSearchValue = ()=>{
      router.push({
        path:'/shop-search',
        query:{
          id:route.query.id,
          keywords:route.query.keywords
        }
      })
      
    }
    let skipPath = ()=>{
       router.go(-2)
    }

    return {
      onLoad,
      loading,
      finished,
      banner,
      screeningClick,
      searchKeyword,
      onSearchValue,
      skipPath
    };
  },
};
